import { selectVillage } from './selectVillage';
import { IState } from '../../store';

export function selectVillageRoadInfoList(state: IState) {
  const village = selectVillage(state);

  return village.roadInfoList ?? [];
}

export function selectVillageRoadsIds(state: IState): number[] {
  return selectVillageRoadInfoList(state).reduce((accumulator, station) => {
    if (station.roadId) {
      accumulator.push(station.roadId);
    }

    return accumulator;
  }, Array.of<number>());
}
